// ----------------------------------------------------------------------
// <copyright file="Izenda.GridDefaultFunction.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import constants from 'logic/data/Izenda.ReportPartFieldConstants';

const FUNCTION = constants.FUNCTION;
const FORMAT_KEY = constants.FORMAT_KEY;

const GROUP_FUNCTION_FORMAT_NONE = {
  FUNCTION: FUNCTION.GROUP,
  FORMAT: FORMAT_KEY.NONE
};

const GROUP_FUNCTION_FORMAT_YEAR = {
  FUNCTION: FUNCTION.GROUP,
  FORMAT: FORMAT_KEY.YEAR
};

const SUM_FUNCTION_FORMAT_NONE = {
  FUNCTION: FUNCTION.SUM,
  FORMAT: FORMAT_KEY.NONE
};

const COUNT_FUNCTION_FORMAT_NONE = {
  FUNCTION: FUNCTION.COUNT,
  FORMAT: FORMAT_KEY.NONE
};

const GROUP_FUNCTION_FORMAT_TIME = {
  FUNCTION: FUNCTION.GROUP,
  FORMAT: FORMAT_KEY.DEFAULT_TIME
};

// Default function for Vertical without separator
const VERTICAL_DEFAULT_FUNCTION = {};

// Default function for Vertical with separator
const VERTICAL_DEFAULT_FUNCTION_WITH_SEPARATORS = {};

// Default function for Vertical with separator
const VERTICAL_DEFAULT_FUNCTION_WITH_AREGATED_FUNCTION = {
  separators: {
    Numeric: GROUP_FUNCTION_FORMAT_NONE,
    Text: GROUP_FUNCTION_FORMAT_NONE,
    Lob: GROUP_FUNCTION_FORMAT_NONE,
    Boolean: GROUP_FUNCTION_FORMAT_NONE,
    Datetime: GROUP_FUNCTION_FORMAT_YEAR,
    Time: GROUP_FUNCTION_FORMAT_NONE,
    Image: GROUP_FUNCTION_FORMAT_NONE,
    Money: GROUP_FUNCTION_FORMAT_NONE
  },
  columns: {
    Numeric: GROUP_FUNCTION_FORMAT_NONE,
    Text: GROUP_FUNCTION_FORMAT_NONE,
    Lob: GROUP_FUNCTION_FORMAT_NONE,
    Boolean: GROUP_FUNCTION_FORMAT_NONE,
    Datetime: GROUP_FUNCTION_FORMAT_YEAR,
    Time: GROUP_FUNCTION_FORMAT_NONE,
    Image: GROUP_FUNCTION_FORMAT_NONE,
    Money: GROUP_FUNCTION_FORMAT_NONE
  }
};

// Default function for horizontal without separator
const HORIZONTAL_DEFAULT_FUNCTION = {};

// Default function for horizontal with separator
const HORIZONTAL_DEFAULT_FUNCTION_WITH_SEPARATORS = {};

// Default function for horizontal with separator
const HORIZONTAL_DEFAULT_FUNCTION_WITH_AREGATED_FUNCTION = {
  separators: {
    Numeric: GROUP_FUNCTION_FORMAT_NONE,
    Text: GROUP_FUNCTION_FORMAT_NONE,
    Lob: GROUP_FUNCTION_FORMAT_NONE,
    Boolean: GROUP_FUNCTION_FORMAT_NONE,
    Datetime: GROUP_FUNCTION_FORMAT_YEAR,
    Time: GROUP_FUNCTION_FORMAT_NONE,
    Image: GROUP_FUNCTION_FORMAT_NONE,
    Money: GROUP_FUNCTION_FORMAT_NONE
  },
  rows: {
    Numeric: GROUP_FUNCTION_FORMAT_NONE,
    Text: GROUP_FUNCTION_FORMAT_NONE,
    Lob: GROUP_FUNCTION_FORMAT_NONE,
    Boolean: GROUP_FUNCTION_FORMAT_NONE,
    Datetime: GROUP_FUNCTION_FORMAT_YEAR,
    Time: GROUP_FUNCTION_FORMAT_NONE,
    Image: GROUP_FUNCTION_FORMAT_NONE,
    Money: GROUP_FUNCTION_FORMAT_NONE
  }
};

// Default function for pivot
const PIVOT_DEFAULT_FUNCTION = {
  columns: {
    Numeric: GROUP_FUNCTION_FORMAT_NONE,
    Text: GROUP_FUNCTION_FORMAT_NONE,
    Boolean: GROUP_FUNCTION_FORMAT_NONE,
    Datetime: GROUP_FUNCTION_FORMAT_YEAR,
    Time: GROUP_FUNCTION_FORMAT_TIME,
    Money: GROUP_FUNCTION_FORMAT_NONE
  },
  rows: {
    Numeric: GROUP_FUNCTION_FORMAT_NONE,
    Text: GROUP_FUNCTION_FORMAT_NONE,
    Boolean: GROUP_FUNCTION_FORMAT_NONE,
    Datetime: GROUP_FUNCTION_FORMAT_YEAR,
    Time: GROUP_FUNCTION_FORMAT_TIME,
    Money: GROUP_FUNCTION_FORMAT_NONE
  },
  values: {
    Numeric: SUM_FUNCTION_FORMAT_NONE,
    Text: COUNT_FUNCTION_FORMAT_NONE,
    Boolean: COUNT_FUNCTION_FORMAT_NONE,
    Datetime: COUNT_FUNCTION_FORMAT_NONE,
    Time: COUNT_FUNCTION_FORMAT_NONE,
    Money: SUM_FUNCTION_FORMAT_NONE
  },
  separators: {
    Numeric: GROUP_FUNCTION_FORMAT_NONE,
    Text: GROUP_FUNCTION_FORMAT_NONE,
    Boolean: GROUP_FUNCTION_FORMAT_NONE,
    Datetime: GROUP_FUNCTION_FORMAT_YEAR,
    Time: GROUP_FUNCTION_FORMAT_TIME,
    Money: GROUP_FUNCTION_FORMAT_NONE
  }
};

// Default function for drill down
const DRILL_DOWN_DEFAULT_FUNCTION = {
  rows: {
    Numeric: GROUP_FUNCTION_FORMAT_NONE,
    Text: GROUP_FUNCTION_FORMAT_NONE,
    Boolean: GROUP_FUNCTION_FORMAT_NONE,
    Datetime: GROUP_FUNCTION_FORMAT_YEAR,
    Time: GROUP_FUNCTION_FORMAT_TIME,
    Money: GROUP_FUNCTION_FORMAT_NONE
  },
  values: {
    Numeric: SUM_FUNCTION_FORMAT_NONE,
    Text: COUNT_FUNCTION_FORMAT_NONE,
    Boolean: COUNT_FUNCTION_FORMAT_NONE,
    Datetime: COUNT_FUNCTION_FORMAT_NONE,
    Time: COUNT_FUNCTION_FORMAT_NONE,
    Money: SUM_FUNCTION_FORMAT_NONE
  },
  separators: {
    Numeric: GROUP_FUNCTION_FORMAT_NONE,
    Text: GROUP_FUNCTION_FORMAT_NONE,
    Boolean: GROUP_FUNCTION_FORMAT_NONE,
    Datetime: GROUP_FUNCTION_FORMAT_YEAR,
    Time: GROUP_FUNCTION_FORMAT_TIME,
    Money: GROUP_FUNCTION_FORMAT_NONE
  }
};

export default {
  PIVOT_DEFAULT_FUNCTION,
  HORIZONTAL_DEFAULT_FUNCTION,
  HORIZONTAL_DEFAULT_FUNCTION_WITH_SEPARATORS,
  HORIZONTAL_DEFAULT_FUNCTION_WITH_AREGATED_FUNCTION,
  DRILL_DOWN_DEFAULT_FUNCTION,
  VERTICAL_DEFAULT_FUNCTION_WITH_SEPARATORS,
  VERTICAL_DEFAULT_FUNCTION,
  VERTICAL_DEFAULT_FUNCTION_WITH_AREGATED_FUNCTION
};



// WEBPACK FOOTER //
// ./ui/logic/data/Izenda.GridDefaultFunction.js